export const GlobalProgressBar = () => {
  return (
    <div className="progress-bar">
      <span className="bar absolute top-0 w-full h-1 z-30">
        <span className="progress-animate" />
      </span>
    </div>
  );
};
